module.exports = __webpack_public_path__ + "static/collaboration1-6a83c25455b880c5616245a67e96ac85.png";